var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page404"},[_c('div',{staticClass:"page404__text-box"},[_c('div',{staticClass:"page404__text--big"},[_vm._v("404")]),_c('div',{staticClass:"page404__text--normal page404__text--grey"},[_vm._v(" Page Not Found ")])])])
}]

export { render, staticRenderFns }